import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import i18n from "../../constants/i18n";
import ET3Div from "../../core/et3-div";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import getCoreSideMenuStore from "../../stores/core/core-side-menu";
import Et3TextInput from "../../core/et3-input/et3-text-input";
import { USER_SEARCH_BY_PLACEHOLDERS } from "../../constants/picker-entries-constants";
import { useNavigate } from "react-router-dom";

const SearchBar = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, unitX, unitY } = theme;
  const navigate = useNavigate();

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={370}
      height={45}
      fDirection="row"
      alignItems="center"
      justifyContent="space-around"
      color={colors.all.white}
      style={{
        borderWidth: 2 * unitX,
        border: `${2 * unitX}px solid ${colors.all.bondiBlue}`,
        borderRadius: 39 * unitX
      }}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={250}
        height={45}
        fDirection="row"
        alignItems="center"
        justifyContent="center"
        color={colors.all.transparent}
        style={{
          justifyContent: "center",
          alignItems: "center"
        }}
        onClick={() => {}}
      >
        <Et3TextInput
          size="MEDIUM"
          withShadow={false}
          icon={null}
          type={"number"}
          label=""
          placeHolder={USER_SEARCH_BY_PLACEHOLDERS.userId}
          value={
            getCoreSideMenuStore().sideBarSearchText.get() === -1
              ? i18n.get("SEARCH")
              : getCoreSideMenuStore().sideBarSearchText.get()
          }
          onChoose={(value: number) => {
            getCoreSideMenuStore().sideBarSearchText.set(value);
          }}
          onBlur={() => {}}
          onEnter={() => {
            const userID = getCoreSideMenuStore().sideBarSearchText.get();
            navigate({
              pathname: "/users/advanced",
              search: `?id=${userID}`
            });
            getCoreSideMenuStore().handleSearch();
          }}
          style={{
            minWidth: 250 * unitX,
            minHeight: 45 * unitY,
            width: 250 * unitX,
            height: 45 * unitY
          }}
        />
      </ET3Div>
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={35}
        height={45}
        fDirection="row"
        alignItems="center"
        justifyContent="center"
        color={colors.all.white}
        style={{
          justifyContent: "center",
          alignItems: "center"
        }}
        onClick={() => {}}
      >
        <FontAwesomeIcon
          style={{
            width: 25 * unitX,
            height: 25 * unitY
          }}
          onClick={() => {
            const userID = getCoreSideMenuStore().sideBarSearchText.get();
            navigate({
              pathname: "/users/advanced",
              search: `?id=${userID}`
            });
            getCoreSideMenuStore().handleSearch();
          }}
          className="clickable"
          icon={faSearch}
          color={colors.all.bondiBlue}
        />
      </ET3Div>
    </ET3Div>
  );
});
export default SearchBar;
